//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherImportInputItem } from './TeacherImportInputItem';
import { NameFormat } from './Enums';

export class TeachersImportInputItem extends ItemBase {
    Teachers: TeacherImportInputItem[] = [];
    NameFormat: NameFormat | null = null;

    constructor(initializer?: Partial<TeachersImportInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeachersImportInputItem";
}
